var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.inquiryFiles),function(inquiryFile,index){return _c('a',{key:index + 1,on:{"click":function($event){return _vm.previewFile(inquiryFile.file_path)}}},[_vm._v("添付ファイル"+_vm._s(index + 1))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }